import React from 'react';
import {
  List,
  Datagrid,
  DateField,
  TextField,
  Filter,
  TextInput,
  CardActions,
  EditButton,
  ShowButton,
  FunctionField,
} from 'react-admin';
import { Button } from '@material-ui/core';
import { BuildOutlined } from '@material-ui/icons/';

const EmailTemplateFilter = props => (
  <Filter {...props}>
    <TextInput label="Name" source="_LIKE_name" alwaysOn />
  </Filter>
);

const onCreateNavigate = (props) => {
  props.history.push('/templateBuilder', { update: false });
};

const Actions = ({ props }) => (
  <CardActions>
    <Button color="primary" onClick={() => onCreateNavigate(props)}>
      <BuildOutlined style={{ marginRight: '10px' }} />
      Build Template
    </Button>
  </CardActions>
);

const ConditionalEditButton = (({ classes, ...props }) => (
  <FunctionField
    {...props}
    render={record => !record.locked && <EditButton {...props} />}
  />
));

export default props => (
  <List
    {...props}
    bulkActionButtons={false}
    filters={<EmailTemplateFilter />}
    title="Email Templates"
    exporter={false}
    actions={<Actions props={props} />}
  >
    <Datagrid >
      <TextField label="Name" source="name" sortable />
      <TextField label="Subject" source="subject" sortable />
      <TextField label="Action" source="action" sortable />
      <TextField label="Type" source="type" sortable />
      <FunctionField
        label="Locked"
        render={record => (record.locked ? 'Yes' : 'No')}
      />
      <DateField source="createdAt" sortable />
      <ConditionalEditButton {...props} />
      <ShowButton />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/components/EmailTemplates/List.js